import {
    Alert,
    Avatar,
    CircularProgress,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography
} from "@mui/material";
import React from "react";
import {useGetWorkOrderProductsQuery} from "../workOrders/workorder_api";
import {useGetProductByIdQuery} from "../products/product_api";
import useDownloadImage from "../storage/useDownloadImage";
import {Tables} from "../../apitypes";
import {usePutRegistrationByIdMutation} from "./reg_api";
import AllOut from "@mui/icons-material/AllOut";


interface Props {
    regid: number
    finished: boolean
    workOrderID: number
    selected: number | null
}


const ProductImage = ({product}: { product: Tables<"product"> | null | undefined }) => {
    const imageUrl = useDownloadImage("products", product?.image_url)
    if (product && imageUrl) {
        return <Avatar src={imageUrl} alt={product.Code}/>
    }
    return <Avatar><AllOut/></Avatar>
}

interface WorkOrderProductLinesProps {
    line: Tables<"workOrderOrderedProduct">
    selected: number | null
    regid: number
    finished: boolean
}

const WorkOrderProductLines = ({finished, selected, line, regid}: WorkOrderProductLinesProps) => {

    const {data, error} = useGetProductByIdQuery({id: line.productCode!,key: "Code"}, {skip: !line.productCode})
    const [put, {isLoading}] = usePutRegistrationByIdMutation();
    return <ListItem
        component="li"
        sx={{
            padding: 0,
            marginBottom: 1,
            backgroundColor: selected == data?.id ? "primary.main" : "transparent"
        }}
        secondaryAction={<Typography variant={"body1"}>{line.calculationQuantity} {data?.Unittext}</Typography>}
        key={line.id}>
        <ListItemButton disabled={finished || isLoading || !data} onClick={() => {
            console.log(line.productCode)
            if (!finished && line.productCode && data) {
                put({id: regid, body: {ProductID: data.id}})
            }
        }}>
            <ListItemIcon>
                {isLoading && <CircularProgress/>}
                {!isLoading && <ProductImage product={data}/>}
            </ListItemIcon>
            <ListItemText
                primary={line.productName}
                secondary={line.productCode + " " + (error ? error.message : "")}/>
        </ListItemButton>
    </ListItem>
}


export default ({regid, finished, selected, workOrderID}: Props) => {

    const {data,error} = useGetWorkOrderProductsQuery({id: workOrderID!})
    return data ? <List>
        {error && <Alert  severity={"error"}>{error.message}</Alert>}
        {data && data.map(p => <WorkOrderProductLines
            finished={finished}
            regid={regid}
            key={p.id}
            selected={selected}
            line={p}
        />)}
    </List> : null
}